import { Box } from "@mui/material";
import React from "react";

export default class ErrorCatcher extends React.Component<
  { children: any },
  { hasError: boolean }
> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state?.hasError) {
      localStorage.removeItem("heg-soundboard-activeTab");
      return (
        <Box style={{ color: "red" }}>
          <h2>Something went wrong.</h2>
          <img
            src={`${process.env.PUBLIC_URL}/sam-run.png`}
            alt="ugly-fuck.png"
            className="error-pic"
            width="250px"
            height="250px"
          />
          <h4>Please refresh the page and don't do whatever you did again.</h4>
        </Box>
      );
    } else {
      return this.props.children;
    }
  }
}
